<template>
  <div>
    <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('entities.category.plural')}}</el-breadcrumb-item>
    </el-breadcrumb>

    <h2 class="page-title"> {{$t('entities.category.plural')}} </h2>

    <el-row :gutter="20">
      <el-col :xs="24" :md="8">
        <el-form @submit.native.prevent class="search" :inline="true">
          <el-form-item>
            <el-input v-model="pager.search" :placeholder="$t('table.search')">
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </el-col>

      <el-col class="button-group" :xs="24" :md="16">
        <el-button
          v-if="hasRoleToCreate"
          icon="el-icon-fa-file-o"
          @click="create()"
          type="primary"
        > {{$t('table.add')}}
        </el-button>
        <el-button
          v-if="hasRoleToReadLogs"
          icon="el-icon-fa-history"
          @click="history()"
          type="infor"
        >
          {{$t('table.history')}}
        </el-button>
        <el-button
                v-if="hasRoleToCreate"
                @click="importCsv()"
                :plain="true"
                type="success"
                icon="el-icon-fa-table"
            > {{$t('table.import')}}
        </el-button>
        <el-button
          v-if="pager.hasDataToExport(list)"
          @click="pager.exportToCsv(list)"
          :plain="true"
          type="primary"
          icon="el-icon-fa-table"
        >
           {{$t('table.export')}}
        </el-button>
      </el-col>
    </el-row>
    <!-- ****************************** -->
        <!-- *                        * -->
        <!-- *  Category import data  * -->      
        <!-- *                        * -->
        <!-- ************************** -->
        <transition name="fade" mode="out-in">
          <router-view name="categoryImport"></router-view>
        </transition>
    <el-table
      :data="pager.paginate(list)"
      :default-sort="{
        prop: 'name',
        order: 'ascending'
      }"
      empty-text="There are no categories yet"
      @sort-change="(args) => pager.sortChange(args)"
      style="width: 100%"
      v-loading="loading"
      border
    >
      <el-table-column
        prop="name"
        label="Name"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        :fixed="isMobile? undefined : 'right'"
        align="center"
        label="Operations"
        width="120"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="hasRoleToRead"
           :content="$t('table.details')"
            placement="top"
          >
            <el-button
              icon="el-icon-fa-search"
              size="small"
              type="text"
              @click="show(scope.row.id)"
            />
          </el-tooltip>

          <el-tooltip
            v-if="hasRoleToUpdate"
           :content="$t('table.edit')"
            placement="top"
          >
            <el-button
              icon="el-icon-fa-pencil-square-o"
              size="small"
              type="text"
              @click="edit(scope.row.id)"
            />
          </el-tooltip>

          <el-tooltip
            v-if="hasRoleToDelete"
           :content="$t('table.delete')"
            placement="top"
          >
            <el-button
              icon="el-icon-fa-trash"
              size="small"
              type="text"
              @click="destroy(scope.row.id)"
            />
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="mt-3">
      <el-pagination
        style="float: right"
        @size-change="(args) => pager.pageSizeChange(args)"
        :current-page.sync="pager.currentPage"
        :layout="paginationLayout"
        :total="pager.filteredAndSortedList(list).length"
        background
      ></el-pagination>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app-category-list',

  computed: {
    ...mapGetters({
      loading: 'entities/category/loading',
      list: 'entities/category/list',
      pager: 'entities/category/pager',
      hasRoleToDelete: "entities/category/hasRoleToDelete",
      hasRoleToUpdate: "entities/category/hasRoleToUpdate",
      hasRoleToRead: "entities/category/hasRoleToRead",
      hasRoleToReadLogs: "entities/category/hasRoleToReadLogs",
      hasRoleToCreate: "entities/category/hasRoleToCreate",
      isMobile: "shared/isMobile",
      paginationLayout: "shared/paginationLayout"
    }),
  },

  created() {
    this.$store.dispatch('entities/category/list');
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/category/clear');
    next();
  },

  beforeRouteUpdate(to, from, next) {
    this.$store.dispatch("entities/category/list");
    next();
  },

  methods: {
    create() {
      this.$router.push({
        name: 'categoryNew',
      });
    },

    show(id) {
      this.$router.push({
        name: 'categoryShow',
        params: { id },
      });
    },

    edit(id) {
      this.$router.push({
        name: 'categoryEdit',
        params: { id },
      });
    },

    destroy(id) {
      this.$confirm('Are you sure?', 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      })
        .then(() =>
          this.$store.dispatch(
            'entities/category/destroy',
            id,
          ),
        )
        .catch(() => {});
    },

    importCsv() {
        this.$router.push({
            name: "categoryImportCsv"
        });
    },

    history() {
      this.$router.push({ name: 'categoryHistoryFull' });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/entities/category/category-list.vue?fe4597cc